import {logout} from '../utilities/AuthService';


export const logOut = (id) => dispatch => {

        logout();
        window.location.href = "/";


};